import { FormattedMessage } from 'react-intl';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FilterItem } from '@molecules/filters/filtersMenu';
import { FilterGeneral } from '@libs/store/filters';
import { Box, Stack } from '@mui/material';

type ProfessionalsFilterMenuProps = {
  localizationSubset: string;
  getFilter: (key: string) => FilterGeneral<string[]> | null;
  key: string;
  options: ProfessionalsOptions[];
};
export function useProfessionalsFilterMenu({
  localizationSubset,
  getFilter,
  key,
  options,
}: ProfessionalsFilterMenuProps): FilterItem {
  const theme = useTheme();
  const filter = getFilter(key);

  return {
    label: <FormattedMessage id={`${localizationSubset}.filters.${key}.label`} />,
    key: key,
    multiple: true,
    searchable: true,
    valueToLabel: (value) => value.map((v) => getTalentName(options.find((l) => l.id === v))).join(', '),
    children: options.map((item) => {
      const name = getTalentName(item);

      return {
        label: (
          <Stack direction="row"  width="100%" alignItems="baseline">
            {name}
            <Box flex={1}/>
            <Typography variant="caption" color={theme.palette.text.secondary}>
              {item.qualifications.map((q) => q.abbreviation).join(', ')}
            </Typography>
          </Stack>
        ),
        text: `${name} ${item.qualifications.map((q) => q.abbreviation).join(', ')}`,
        key: item.id,
        selected: filter?.value.includes(item.id) || false,
      };
    }),
  };
}

function getTalentName(talent?: ProfessionalsOptions) {
  if (!talent) {
    return;
  }
  return [talent.firstName, talent.lastName].filter(Boolean).join(' ');
}

type ProfessionalsOptions = {
  id: string;
  firstName: string;
  lastName: string;
  qualifications: {
    abbreviation: string;
  }[];
};
